import { Link, useNavigate } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import ProjectIcon from '../components/ProjectIcon';
import AnimatedBanner from '../components/AnimatedBanner';
import { services } from '../data/services';
import './Projects.css';
import './Services.css';

const Services = () => {
  const navigate = useNavigate();

  return (
    <div className="page-shell">
      <title>Services - Pidesk</title>
      <meta name="description" content="Web development, SaaS products, custom software, mobile apps, data architecture and tech consulting from Pidesk." />

      <div className="container">
        <div className="page-hero">
          <span className="projects-eyebrow">Services</span>
          <h1 className="page-title">Our Services</h1>
          <p className="page-subtitle">We build digital products that drive growth and empower users. Open any service to see what's included.</p>
        </div>

        <div className="projects-grid">
          {services.map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`} className={`project-card tone-${s.tone}`}>
              <span className="project-open"><ArrowUpRight size={18} /></span>
              <div className="pc-text">
                <span className="project-category">Service</span>
                <h3 className="project-name">{s.title}</h3>
                <p className="project-desc">{s.tagline}</p>
              </div>
              <div className="pc-art">
                <div className="pc-mock">
                  <div className="pc-mock-title">What's included</div>
                  {s.features.slice(0, 3).map((f) => (
                    <div key={f.title} className="pc-sched"><span>{f.title}</span></div>
                  ))}
                </div>
                <div className="pc-pill"><ProjectIcon name={s.icon} size={14} /> {s.features.length} features</div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <section className="section" style={{ padding: '60px 0 20px' }}>
        <div className="container">
          <AnimatedBanner
            title="Have an idea?"
            subtitle="Share your project vision with Pidesk and let us build it together."
            buttonText="Submit Project"
            type="primary"
            onClick={() => navigate('/contact')}
          />
        </div>
      </section>
    </div>
  );
};

export default Services;
